import React from "react";
import ReactDOM from "react-dom";

if (window.__INITIAL_STATE_autosuggest_search_bar__) {
  (async () => {
    const { default: App } = await import("./App");
    ReactDOM.hydrate(<App />, document.getElementById("search-bar-root"));
  })();
}
